export default "__VITE_ASSET__CiwSG2pB__"